var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRotateApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.4466C11.4867 19.4466 10.9733 19.2533 10.5867 18.8599L7.75999 16.0333C6.97999 15.2533 6.97999 13.9866 7.75999 13.2066L10.5867 10.3799C11.3667 9.59992 12.6333 9.59992 13.4133 10.3799L16.24 13.2066C17.02 13.9866 17.02 15.2533 16.24 16.0333L13.4133 18.8599C13.0267 19.2466 12.5133 19.4466 12 19.4466ZM11.5267 17.9199C11.7867 18.1799 12.2133 18.1799 12.4667 17.9199L15.2933 15.0933C15.5533 14.8333 15.5533 14.4133 15.2933 14.1466L12.4667 11.3199C12.2067 11.0599 11.7867 11.0599 11.5267 11.3199L8.69999 14.1466C8.43999 14.4066 8.43999 14.8266 8.69999 15.0933L11.5267 17.9199Z",
    fill: "#5E6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.84 10.6266C17.7666 10.6533 17.6933 10.6666 17.62 10.6666C17.3466 10.6666 17.0866 10.4933 16.9933 10.2199C16.2466 8.09325 14.2266 6.66659 11.9666 6.66659C10.3266 6.66659 8.80665 7.41325 7.81331 8.66659H7.99998C8.36665 8.66659 8.66665 8.96659 8.66665 9.33325C8.66665 9.69992 8.36665 9.99992 7.99998 9.99992H5.99998C5.63331 9.99992 5.33331 9.69992 5.33331 9.33325V7.33325C5.33331 6.96659 5.63331 6.66659 5.99998 6.66659C6.36665 6.66659 6.66665 6.96659 6.66665 7.33325V7.96659C7.90665 6.31992 9.85331 5.33325 11.9666 5.33325C14.7933 5.33325 17.3133 7.11992 18.2466 9.77992C18.3733 10.1266 18.1866 10.5066 17.84 10.6266Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateApp);
export default __webpack_public_path__ + "static/media/ICON_ROTATE_APP.e87ee97fd5e5b0a3ca5a8ed81463e8ed.svg";
export { ForwardRef as ReactComponent };